import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Button } from "@/components/ui/button";

export default function StickyMobileCTA({ visible, onClick }) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          className="md:hidden fixed bottom-0 left-0 right-0 z-40 p-3 glass border-t border-white/40"
          data-testid="sticky-mobile-cta"
        >
          <Button
            onClick={onClick}
            className="w-full h-14 rounded-full bg-[#F97316] hover:bg-[#EA580C] text-white text-base font-bold cta-glow"
            data-testid="sticky-cta-button"
          >
            Get Instant Access – ₹199
          </Button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
